import { createActionsWithPrefix } from "../../helperfunctions/action";

export const DashboardActions = createActionsWithPrefix("DASHBOARD/", {
    GET_LATESTRESULTS_REQUEST: "GET_LATESTRESULTS_REQUEST",
    GET_LATESTRESULTS_SUCCESS: "GET_LATESTRESULTS_SUCCESS",
    GET_LATESTRESULTS_ERROR: "GET_LATESTRESULTS_ERROR",
    GET_UPCOMING_COURSES_REQUEST: "GET_UPCOMING_COURSES_REQUEST",
    GET_UPCOMING_COURSES_SUCCESS: "GET_UPCOMING_COURSES_SUCCESS",
    GET_UPCOMING_COURSES_ERROR: "GET_UPCOMING_COURSES_ERROR",
});